<template>
    <div id="container">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'PageView'
}
</script>
<style scoped>
#container {
    flex: 1
}
</style>




// WEBPACK FOOTER //
// src/view/PageView.vue